export function token() {
  const tok = document.querySelector('meta[name="csrf-token"]');
  return tok && tok.getAttribute('content');
}
export function param() {
  const par = document.querySelector('meta[name="csrf-param"]');
  return par && par.getAttribute('content');
}
